import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import HeadTabs from "../../globalComponents/HeadTabs/HeadTabs";
import { useDispatch } from "react-redux";
import {
  getStudentPerformanceCommonResults,
  getStudentPerformanceResults,
} from "../../redux/actions/studentPerformanceActions";
import StudentPerformanceData from "./components/StudentPerformanceData";
import GlobalHead from "../../globalComponents/GlobalHead/GlobalHead";
import { STUDENT_PERFORMANCE_MODAL_ACTION_TYPE } from "../../redux/actions-type";
import StudentPerformanceCommonData from "./components/StudentPerformanceCommonData";

const StudentPerformancePage = () => {
  const { group, student } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes("common")) {
       dispatch(getStudentPerformanceCommonResults(student, group));
    } else {
      dispatch(getStudentPerformanceResults(student, group));
     
    }
  }, [location?.pathname,group,student,dispatch]);

  const openModal = () => {
    dispatch({
      type: STUDENT_PERFORMANCE_MODAL_ACTION_TYPE.GET_STUDENT_PERFORMANCE_MODAL,
      payload: {
        data: {
          student,
          group,
        },
        openModal: true,
      },
    });
  };

  return (
    <div className="details-page teachers-page ">
    {/* {!location?.pathname.includes("common") &&  <GlobalHead openModal={openModal} statusType="student-performance"  profile="students"  />} */}
      <HeadTabs
        firstRoute={`/student-performance/${student}/${group}`}
        secondRoute={`/student-common-performance/${student}/${group}`}
        firstPathname={"Aylıq nəticə"}
        secondPathname={"Ümumi nəticə"}
      />
    {location?.pathname.includes("common") ? <StudentPerformanceCommonData/> :  <StudentPerformanceData />}
    </div>
  );
};

export default StudentPerformancePage;
